export const trackAnalyticsEvent = (eventName, params = {}) => {
  if (window.gtag) {
    window.gtag("event", eventName, params);
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    ...params,
  });
};
